import { ProductModel } from '@app/features/home/store/products/products.model';

import { AddToCartPayload } from './cart.model';

export class UpdateDiscountTiersFromProductsAction {
  static readonly type = '[Cart] Update Discount Tiers from Products';
  constructor(public products: ProductModel[]) {}
}

export class AddToCartAction {
  static readonly type = '[Cart] Add item';
  constructor(public item: AddToCartPayload) {}
}

export class RemoveFromCartAction {
  static readonly type = '[Cart] Remove item';
  constructor(public id: number) {}
}

export class IncrementQuantityAction {
  static readonly type = '[Cart] Increment quantity';
  constructor(public id: number) {}
}

export class DecrementQuantityAction {
  static readonly type = '[Cart] Decrement quantity';
  constructor(public id: number) {}
}

export class UpdateQuantityAction {
  static readonly type = '[Cart] Update Quantity';
  constructor(public payload: { id: number; quantity: number }) {}
}

export class ClearCartAction {
  static readonly type = '[Cart] Clear cart';
  constructor(public studentId?: number) {}
}

export class ClearAllCartsAction {
  static readonly type = '[Cart] Clear all carts';
  constructor() {}
}
